import { render, staticRenderFns } from "./account-payments-overview.vue?vue&type=template&id=177977d1"
import script from "./account-payments-overview.vue?vue&type=script&lang=js"
export * from "./account-payments-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports